/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface Marvelpay
 */
export class Marvelpay {
    /**
     *
     * @type {string}
     * @memberof Marvelpay
     */
    _id: string;
    /**
     *
     * @type {string}
     * @memberof Marvelpay
     */
    namespace: string;
    /**
     *
     * @type {string}
     * @memberof Marvelpay
     */
    type: string;
    /**
     *
     * @type {string}
     * @memberof Marvelpay
     */
    host: string;
    /**
     *
     * @type {string}
     * @memberof Marvelpay
     */
    apiKey: string;
    /**
     *
     * @type {string}
     * @memberof Marvelpay
     */
    secretKey: string;
    /**
     *
     * @type {boolean}
     * @memberof Marvelpay
     */
    sandbox: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Marvelpay
     */
    autoApprove: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Marvelpay
     */
    amountFromPsp: boolean;
}
